
// import axios from 'axios'

const state = {
  disable_change_phase: { 'value': 'true' },
  manual_change_phase: { 'value': 'false' },
  selected_input: { 'value': '' },
  dialogInfo: {'active': false, 'text': ''},
  config: {},
  inputs: {
    czas_podtrzymania: { 'value': 24 },
    czas_alarmowania: { 'value': 0.5 },
    dodatkowe_u: { 'value': 0, 'min': 0, 'max': 50 },
    glebokosc_szafy: {'value': 600, 'active': false},
    sieciowanie_systemu: { 'value': 'nie' },
    tryb_poboru_mocy: { 'value': 'standby' },

    wzmacniacz: { 'value': 0, 'min': 0, 'max': 9 },
    wzmacniacz_rezerwowy: { 'value': 0, 'min': 0, 'max': 9 },
    kontroler: { 'value': 0, 'min': 0, 'max': 1 },
    router: { 'value': 0, 'min': 0, 'max': 6 },

    wariant1: { 'value': 0, 'min': 0, 'max': 1 },
    wariant1_rozszerzenia: { 'value': 0, 'min': 0, 'max': 1 },
    wariant2: { 'value': 0, 'min': 0, 'max': 16 },
    wariant2_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    wariant3: { 'value': 0, 'min': 0, 'max': 16 },
    wariant3_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    wariant4: { 'value': 0, 'min': 0, 'max': 16 },
    wariant4_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
    // wariant5: { 'value': 0, 'min': 0, 'max': 16 },
    // wariant5_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },

    obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 },
    panel_wentylacyjny: { 'value': 0, 'min': 0, 'max': 1 },
    kolka: { 'value': 0, 'min': 0, 'max': 1 },

    sygnal_pilota_cb: { 'value': false },
    sygnal_pilota: { 'value': 0, 'min': 0, 'max': 9000 },
    moc_glosnikow: { 'value': 0, 'min': 0, 'max': 9000 },
    moc_systemu: { 'value': 0 }
  },
  outputs: {
    szafa: {
      kod: '',
      nazwa: '',
      id: '',
      gen_code: '',
      attributes: {
        wysokosc: '',
        mm: '',
        szerokosc: '',
        glebokosc: '',
        cena: '',
        waga: ''
      }
    },
    zasilacz: {
      klasa: '',
      kod: '',
      nazwa: '',
      grupa: '',
      gen_code: '',
      current: {
        standby: '',
        normal: '',
        speech: '',
        alarm: ''
      },
      attributes: {
        moc: '',
        pobor: '',
        wyjscia: '',
        ciag: '',
        wysokosc: '',
        cena: '',
        waga: ''
      }
    },
    akumulator: {
      kod: '',
      nazwa: '',
      gen_code: '',
      pojemnosc: '',
      ilosc: '',
      polki: '',
      wysokosc: '',
      waga: '',
      cena: '',
      prad: ''
    },
    mozliwe_akumulatory: {},
    akumulator_user: {'value': false},
    szafa_user: {'value': false},
    stale_w_szafie: {},
    liczba_lini: {'value': 0},
    pobor_pradu: {'value': 0},
    moc_cieplna: {'value': 0},
    ilosc_faz: {'value': 0},
    zabezpieczenia: {'value': 0},
    zapas_pojemnosci: {'value': 0},
    szafa_wolne_miejsce: {'value': 0},
    przylacze_zasilania: {'value': ''},
    waga_instalacyjna: {'value': 0},
    cena_netto_systemu: {'value': 0},
    cena_netto_systemu_bez_rabatu: {'value': 0},
    cena_netto_calkowita: {'value': 0},
    cena_netto_bez_rabatu: {'value': 0},
    rabat: {'value': 0},
    numer_konfiguracji: {'value': ''},

    moc_naglosnienia: {'value': ''},
    moc_zasilacza: {'value': 0},
    akumulatory_typ: {'value': 0},
    akumulatory_liczba: {'value': 0},
    akumulatory_zapas: {'value': 0},
    akumulatory_waga: {'value': 0},
    zabezp_bezpiecznikowe: {'value': 0},
    szafa_wysokosc: {'value': 0},
    szafa_wysokosc_mm: {'value': 0},
    szafa_rozmiar: {'value': 0},
    szafa_waga: {'value': 0},

    zamawiajacy: {
      nazwa: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: '',
      email: '',
      nip: ''
    },
    inwestycja: {
      nazwa: '',
      biuro_projektant: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: '',
      email: ''
    },
    wysylka: {
      nazwa: '',
      imie_nazwisko: '',
      adres: '',
      kod_miasta: '',
      miasto: '',
      tel: ''
    },
    nazwaPliku: {'value': ''}
  },
  loading: false,
  refCount: 0
}

const getters = {
  inputs: state => state.inputs,
  outputs: state => state.outputs,
  config: state => state.config,
  loading: state => state.loading,
  refCount: state => state.refCount,
  dialogInfo: state => state.dialogInfo,
  selected_input: state => state.selected_input
}

const mutations = {
  SET_LOADING (state, loading) {
    if (loading) {
      state.refCount++
      state.loading = loading
    } else {
      state.refCount--
      state.loading = loading
    }
    state.loading = state.refCount !== 0
  },

  SET_DIALOG_INFO (state, payload) {
    state.dialogInfo.active = payload.active
    state.dialogInfo.text = payload.text
  },

  SET_CONFIG (state, payload) {
    state.config = payload
  },

  UPDATED_SELECTED_INPUT (state, payload) {
    state.selected_input = payload
  },

  UPDATED_INPUTS (state, payload) {
    if (state.inputs[payload['name']]) {
      if (payload.type === 'value') {
        state.inputs[payload['name']]['value'] = payload['val']
      }
      if (payload.type === 'min') {
        state.inputs[payload['name']]['min'] = payload['val']
      }
      if (payload.type === 'max') {
        state.inputs[payload['name']]['max'] = payload['val']
      }
      if (payload.type === 'active') {
        state.inputs[payload['name']]['active'] = payload['val']
      }
    }
  },

  UPDATED_OUTPUTS (state, payload) {
    if (state.outputs[payload['name']]) {
      if (payload.type === 'value') {
        state.outputs[payload['name']]['value'] = payload['val']
      }
      if (payload.type === 'min') {
        state.outputs[payload['name']]['min'] = payload['val']
      }
      if (payload.type === 'max') {
        state.outputs[payload['name']]['max'] = payload['val']
      }
      if (payload.type === 'array') {
        state.outputs[payload['name']] = payload['val']
      }
    }
  },

  UPDATE_VALUE (state, payload) {
    if (payload.type === 'value') {
      state[payload['name']]['value'] = payload['val']
    }
  },

  UPDATED_CONFIG (state, payload) {
    if (payload.type === 'value') {
      state.config[payload['name']]['value'] = payload['val']
    }
  },

  CLEAR_INPUTS (state) {
    state.inputs = {
      czas_podtrzymania: { 'value': 24 },
      czas_alarmowania: { 'value': 0.5 },
      dodatkowe_u: { 'value': 0, 'min': 0, 'max': 50 },
      glebokosc_szafy: { 'value': 600, 'active': false },
      sieciowanie_systemu: { 'value': 'nie' },
      tryb_poboru_mocy: { 'value': 'standby' },

      wzmacniacz: { 'value': 0, 'min': 0, 'max': 9 },
      wzmacniacz_rezerwowy: { 'value': 0, 'min': 0, 'max': 9 },
      kontroler: { 'value': 0, 'min': 0, 'max': 1 },
      router: { 'value': 0, 'min': 0, 'max': 6 },

      wariant1: { 'value': 0, 'min': 0, 'max': 1 },
      wariant1_rozszerzenia: { 'value': 0, 'min': 0, 'max': 1 },
      wariant2: { 'value': 0, 'min': 0, 'max': 16 },
      wariant2_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
      wariant3: { 'value': 0, 'min': 0, 'max': 16 },
      wariant3_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
      wariant4: { 'value': 0, 'min': 0, 'max': 16 },
      wariant4_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
      // wariant5: { 'value': 0, 'min': 0, 'max': 16 },
      // wariant5_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },

      obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 },
      panel_wentylacyjny: { 'value': 0, 'min': 0, 'max': 1 },
      kolka: { 'value': 0, 'min': 0, 'max': 1 },

      sygnal_pilota_cb: { 'value': false },
      sygnal_pilota: { 'value': 0, 'min': 0, 'max': 9000 },
      moc_glosnikow: { 'value': 0, 'min': 0, 'max': 9000 },
      moc_systemu: { 'value': 0 }
    }
  },

  CLEAR_OUTPUTS (state) {
    state.outputs = {
      szafa: {
        kod: '',
        nazwa: '',
        id: '',
        gen_code: '',
        attributes: {
          wysokosc: '',
          mm: '',
          szerokosc: '',
          glebokosc: '',
          cena: '',
          waga: ''
        }
      },
      zasilacz: {
        klasa: '',
        kod: '',
        nazwa: '',
        grupa: '',
        gen_code: '',
        current: {
          standby: '',
          normal: '',
          speech: '',
          alarm: ''
        },
        attributes: {
          moc: '',
          pobor: '',
          wyjscia: '',
          ciag: '',
          wysokosc: '',
          cena: '',
          waga: ''
        }
      },
      akumulator: {
        kod: '',
        nazwa: '',
        gen_code: '',
        pojemnosc: '',
        ilosc: '',
        polki: '',
        wysokosc: '',
        waga: '',
        cena: '',
        prad: ''
      },
      mozliwe_akumulatory: {},
      akumulator_user: {'value': false},
      szafa_user: {'value': false},
      stale_w_szafie: {},
      liczba_lini: {'value': 0},
      pobor_pradu: {'value': 0},
      moc_cieplna: {'value': 0},
      ilosc_faz: {'value': 0},
      zabezpieczenia: {'value': 0},
      zapas_pojemnosci: {'value': 0},
      szafa_wolne_miejsce: {'value': 0},
      przylacze_zasilania: {'value': ''},
      waga_instalacyjna: {'value': 0},
      cena_netto_systemu: {'value': 0},
      cena_netto_systemu_bez_rabatu: {'value': 0},
      cena_netto_calkowita: {'value': 0},
      cena_netto_bez_rabatu: {'value': 0},
      rabat: {'value': 0},
      numer_konfiguracji: {'value': ''},

      moc_naglosnienia: {'value': ''},
      moc_zasilacza: {'value': 0},
      akumulatory_typ: {'value': 0},
      akumulatory_liczba: {'value': 0},
      akumulatory_zapas: {'value': 0},
      akumulatory_waga: {'value': 0},
      zabezp_bezpiecznikowe: {'value': 0},
      szafa_wysokosc: {'value': 0},
      szafa_wysokosc_mm: {'value': 0},
      szafa_rozmiar: {'value': 0},
      szafa_waga: {'value': 0},

      zamawiajacy: {
        nazwa: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: '',
        nip: ''
      },
      inwestycja: {
        nazwa: '',
        biuro_projektant: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: ''
      },
      wysylka: {
        nazwa: '',
        imie_nazwisko: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: ''
      },
      nazwaPliku: {'value': ''}
    }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js